import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectInputProps } from '@mui/material/Select/SelectInput';
import { Units } from 'Types';

const labelsByUnit: Record<Units, string> = {
  [Units.IN]: 'Imperial - in',
  [Units.MM]: 'Metric - mm',
};

type Props = {
  value: Units;
  onChange: (units: Units) => void;
  isCompact: boolean;
};

function UnitSelector(props: Props) {
  const { isCompact, onChange, value } = props;

  const _onChange: SelectInputProps['onChange'] = (event) =>
    onChange(event.target.value as Units);

  return (
    <FormControl variant="standard">
      <InputLabel id="units-label">Units</InputLabel>
      <Select
        labelId="units-label"
        value={value}
        onChange={_onChange}
        renderValue={(value) => (isCompact ? value : labelsByUnit[value])}
      >
        <MenuItem value={Units.IN}>{labelsByUnit[Units.IN]}</MenuItem>
        <MenuItem value={Units.MM}>{labelsByUnit[Units.MM]}</MenuItem>
      </Select>
    </FormControl>
  );
}

export default UnitSelector;
